module.exports = __webpack_public_path__ + "img/banner1.e92349cf.png";